/**
 * Game constants and base values
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.980Z
 */

import { ConfigType } from './ConfigType';

export interface ConstantsConfig {
  key: string;
  value: string | number | null;
  note: any | null;
  configType: ConfigType.GAME_CONSTANTS;
}

export const constantsData: Record<string, ConstantsConfig> = {
  K_SELL_MULT: {
    key: 'K_SELL_MULT',
    value: 1,
    note: 'глобальный множитель цены продажи предметов. Поднимает/опускает весь доход в золоте без пересчёта каталогов. Юзкейс: быстрое выравнивание GPM.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_BAR_PRICE_MULT: {
    key: 'K_BAR_PRICE_MULT',
    value: 1,
    note: 'глобальный множитель цены продажи сплавов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRAFT_TIME_BASE: {
    key: 'K_CRAFT_TIME_BASE',
    value: 6,
    note: 'базовое время на рецепт до модификаторов (сек). Двигает темп «крафт-петель».',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRAFT_TIME_TIER_STEP: {
    key: 'K_CRAFT_TIME_TIER_STEP',
    value: 0.2,
    note: 'Надбавка времени за tier рецепта',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRAFT_YIELD_BASE: {
    key: 'K_CRAFT_YIELD_BASE',
    value: 1,
    note: 'базовый выход рецепта (до % выходов/оверпрода). Держит маржу ремесла под контролем.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_A[laser]': {
    key: 'K_UPG_COST_A[laser]',
    value: 250,
    note: 'стартовая цена апгрейда в группе (seed кривой) лазерного бура',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_A[bombs]': {
    key: 'K_UPG_COST_A[bombs]',
    value: 200,
    note: 'стартовая цена апгрейда в группе (seed кривой) бомб',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_A[utility]': {
    key: 'K_UPG_COST_A[utility]',
    value: 150,
    note: 'стартовая цена апгрейда в группе (seed кривой) прочих апгрейдов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_B[laser]': {
    key: 'K_UPG_COST_B[laser]',
    value: 1.22,
    note: 'мультипликатор роста цены по уровням (cost = A * B^n). Степень «инфляции» внутри группы.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_B[bombs]': {
    key: 'K_UPG_COST_B[bombs]',
    value: 1.2,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_UPG_COST_B[utility]': {
    key: 'K_UPG_COST_B[utility]',
    value: 1.18,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_OFFLINE_MULT: {
    key: 'K_OFFLINE_MULT',
    value: 0.55,
    note: 'множитель офлайн-дохода vs онлайн. Регулирует «idle-ощущение» без правки формул.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_BASE_RADIUS: {
    key: 'K_BASE_RADIUS',
    value: 64,
    note: 'базовый радиус майнилкки',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_DAMAGE_BASE: {
    key: 'K_DAMAGE_BASE',
    value: 1,
    note: 'базовый урон за удар',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRIT_CHANCE_BASE: {
    key: 'K_CRIT_CHANCE_BASE',
    value: '5.00%',
    note: 'базовый шанс крита (до бонусов). Влияет на раннюю «живость» урона.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRIT_MULT: {
    key: 'K_CRIT_MULT',
    value: 2,
    note: ['базовый множитель крита (x). Контролит', 'сколько ДПС сидит в критах.'],
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_BOMB_AOE_BASE: {
    key: 'K_BOMB_AOE_BASE',
    value: 2.2,
    note: 'базовый радиус АоЕ бомб. Драйвит «скорость зачистки» этажей.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_MINING_TICK: {
    key: 'K_MINING_TICK',
    value: 0.3,
    note: 'длительность тика майнинга (сек). Влияет на сглаженность урона/TTK и нагрузку.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRIT_DSP_MULT_BASE: {
    key: 'K_CRIT_DSP_MULT_BASE',
    value: 1.05,
    note: 'базовый крит урон в секунду',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_DPS_EFF_BASE: {
    key: 'K_DPS_EFF_BASE',
    value: 3.5,
    note: 'базовый эффективный урон в секунду',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_BASE_HP_MULT: {
    key: 'K_BASE_HP_MULT',
    value: 0.5,
    note: 'параметр для быстрого управления базовым HP астероидов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SECTOR_HP_GROWTH: {
    key: 'K_SECTOR_HP_GROWTH',
    value: 0.065,
    note: 'рост прочности сектора за индекс (hp_mult = (1+K)^(i-1)). Главный рычаг «ступеней» сложности.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SIZE_TTK_PEBBLE: {
    key: 'K_SIZE_TTK_PEBBLE',
    value: 1,
    note: 'целевой TTK на этаже 1 для разных размеров астероидов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SIZE_TTK_SMALL: {
    key: 'K_SIZE_TTK_SMALL',
    value: 2,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SIZE_TTK_MEDIUM: {
    key: 'K_SIZE_TTK_MEDIUM',
    value: 4,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SIZE_TTK_LARGE: {
    key: 'K_SIZE_TTK_LARGE',
    value: 8,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SIZE_TTK_COLOSSAL: {
    key: 'K_SIZE_TTK_COLOSSAL',
    value: 16,
    note: null,
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_FRAG_HP_RATIO: {
    key: 'K_FRAG_HP_RATIO',
    value: 0.4,
    note: 'HP каждого осколка от родителя',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_FRAG_LOOT_RATIO: {
    key: 'K_FRAG_LOOT_RATIO',
    value: 0.35,
    note: 'доля лута родителя на каждого осколка',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_SPAWN_DENSITY_BASE: {
    key: 'K_SPAWN_DENSITY_BASE',
    value: 1,
    note: 'базовая плотность спавна блоков/астероидов. Темп контента на экран.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_ASTEROID_SIZE_WEIGHTS[S]': {
    key: 'K_ASTEROID_SIZE_WEIGHTS[S]',
    value: 0.55,
    note: 'вес спауна маленьких астероидов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_ASTEROID_SIZE_WEIGHTS[M]': {
    key: 'K_ASTEROID_SIZE_WEIGHTS[M]',
    value: 0.35,
    note: 'вес спауна средних астероидов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_ASTEROID_SIZE_WEIGHTS[L]': {
    key: 'K_ASTEROID_SIZE_WEIGHTS[L]',
    value: 0.1,
    note: 'вес спауна больших астероидов',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_VALUE_HP_MULT_BASIC: {
    key: 'K_VALUE_HP_MULT_BASIC',
    value: 1,
    note: 'множитель HP за «ценность»',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_VALUE_HP_MULT_RICH: {
    key: 'K_VALUE_HP_MULT_RICH',
    value: 1.2,
    note: '… богаче → толще',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_VALUE_HP_MULT_RARE: {
    key: 'K_VALUE_HP_MULT_RARE',
    value: 1.45,
    note: '…',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_DROP_ROLLS_BASE: {
    key: 'K_DROP_ROLLS_BASE',
    value: 2,
    note: 'базовое число бросков лута на источник (до мультов удачи). Контролит «на сколько сыпет».',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_WEIGHT_FLOOR: {
    key: 'K_WEIGHT_FLOOR',
    value: 1,
    note: 'минимальный эффективный вес редких предметов (анти-голод). Снижает «сухие серии».',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_RARE_PITY_STEP: {
    key: 'K_RARE_PITY_STEP',
    value: '8.00%',
    note: 'шаг pity-счётчика (насколько растёт шанс редкого при неудачах). Ускоряет «награду за терпение».',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_SOFTCAP_START[craft_speed]': {
    key: 'K_SOFTCAP_START[craft_speed]',
    value: '120.00%',
    note: 'софт-кэп скорости крафта',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_SOFTCAP_START[loot_mult]': {
    key: 'K_SOFTCAP_START[loot_mult]',
    value: '150.00%',
    note: 'софт-кэп скорости мультиплаера лута',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_SOFTCAP_START[bomb_aoe]': {
    key: 'K_SOFTCAP_START[bomb_aoe]',
    value: '100.00%',
    note: 'софт-кэп радиуса бомбы',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_SOFTCAP_SLOPE[stat]': {
    key: 'K_SOFTCAP_SLOPE[stat]',
    value: null,
    note: 'насколько «ломается» прирост после старта (напр. делить дельту на 2/3/5).',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_CRIT_CAP: {
    key: 'K_CRIT_CAP',
    value: 0.75,
    note: 'жёсткий потолок шанса крита (если нужен).',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_LOOT_MULT_CAP: {
    key: 'K_LOOT_MULT_CAP',
    value: '250.00%',
    note: 'потолок мультипликатора лута (анти-дегенеративные фарм-петли).',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_GLOBAL_SPEED_DEBUFF[G1]': {
    key: 'K_GLOBAL_SPEED_DEBUFF[G1]',
    value: null,
    note: 'глобальный множитель скорости игры мира 1. Потом снимается апгрейдами/ивентами.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_TARGET_TTK: {
    key: 'K_TARGET_TTK',
    value: 7.5,
    note: 'целевой TTK медианного блока (сек) на текущем секторе. Держит «ощущение темпа» в коридоре.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  'K_TARGET_GPM[W1]': {
    key: 'K_TARGET_GPM[W1]',
    value: 1,
    note: 'ориентир gold/min на галактику. Под него калибруем цены апгрейдов/рецептов.',
    configType: ConfigType.GAME_CONSTANTS,
  },
  K_RARE_RATE_TARGET: {
    key: 'K_RARE_RATE_TARGET',
    value: '2.50%',
    note: 'целевая доля редкого дропа на цикл. Сверяемся после pity и весов.',
    configType: ConfigType.GAME_CONSTANTS,
  },
};

/**
 * Get ConstantsConfig by key
 */
export function getConstants(id: string): ConstantsConfig | undefined {
  return constantsData[id];
}

/**
 * Get all ConstantsConfig entries
 */
export function getAllConstants(): ConstantsConfig[] {
  return Object.values(constantsData);
}

/**
 * Check if ConstantsConfig exists
 */
export function hasConstants(id: string): boolean {
  return id in constantsData;
}

/** Typed union of keys for IDE autocomplete */
export type ConstantsConfigKey = keyof typeof constantsData;

/** Readable key map (PascalCase → real key) for safer usage */
export const K = {
  KSELLMULT: 'K_SELL_MULT',
  KBARPRICEMULT: 'K_BAR_PRICE_MULT',
  KCRAFTTIMEBASE: 'K_CRAFT_TIME_BASE',
  KCRAFTTIMETIERSTEP: 'K_CRAFT_TIME_TIER_STEP',
  KCRAFTYIELDBASE: 'K_CRAFT_YIELD_BASE',
  KUPGCOSTALaser: 'K_UPG_COST_A[laser]',
  KUPGCOSTABombs: 'K_UPG_COST_A[bombs]',
  KUPGCOSTAUtility: 'K_UPG_COST_A[utility]',
  KUPGCOSTBLaser: 'K_UPG_COST_B[laser]',
  KUPGCOSTBBombs: 'K_UPG_COST_B[bombs]',
  KUPGCOSTBUtility: 'K_UPG_COST_B[utility]',
  KOFFLINEMULT: 'K_OFFLINE_MULT',
  KBASERADIUS: 'K_BASE_RADIUS',
  KDAMAGEBASE: 'K_DAMAGE_BASE',
  KCRITCHANCEBASE: 'K_CRIT_CHANCE_BASE',
  KCRITMULT: 'K_CRIT_MULT',
  KBOMBAOEBASE: 'K_BOMB_AOE_BASE',
  KMININGTICK: 'K_MINING_TICK',
  KCRITDSPMULTBASE: 'K_CRIT_DSP_MULT_BASE',
  KDPSEFFBASE: 'K_DPS_EFF_BASE',
  KBASEHPMULT: 'K_BASE_HP_MULT',
  KSECTORHPGROWTH: 'K_SECTOR_HP_GROWTH',
  KSIZETTKPEBBLE: 'K_SIZE_TTK_PEBBLE',
  KSIZETTKSMALL: 'K_SIZE_TTK_SMALL',
  KSIZETTKMEDIUM: 'K_SIZE_TTK_MEDIUM',
  KSIZETTKLARGE: 'K_SIZE_TTK_LARGE',
  KSIZETTKCOLOSSAL: 'K_SIZE_TTK_COLOSSAL',
  KFRAGHPRATIO: 'K_FRAG_HP_RATIO',
  KFRAGLOOTRATIO: 'K_FRAG_LOOT_RATIO',
  KSPAWNDENSITYBASE: 'K_SPAWN_DENSITY_BASE',
  KASTEROIDSIZEWEIGHTSS: 'K_ASTEROID_SIZE_WEIGHTS[S]',
  KASTEROIDSIZEWEIGHTSM: 'K_ASTEROID_SIZE_WEIGHTS[M]',
  KASTEROIDSIZEWEIGHTSL: 'K_ASTEROID_SIZE_WEIGHTS[L]',
  KVALUEHPMULTBASIC: 'K_VALUE_HP_MULT_BASIC',
  KVALUEHPMULTRICH: 'K_VALUE_HP_MULT_RICH',
  KVALUEHPMULTRARE: 'K_VALUE_HP_MULT_RARE',
  KDROPROLLSBASE: 'K_DROP_ROLLS_BASE',
  KWEIGHTFLOOR: 'K_WEIGHT_FLOOR',
  KRAREPITYSTEP: 'K_RARE_PITY_STEP',
  KSOFTCAPSTARTCraftSpeed: 'K_SOFTCAP_START[craft_speed]',
  KSOFTCAPSTARTLootMult: 'K_SOFTCAP_START[loot_mult]',
  KSOFTCAPSTARTBombAoe: 'K_SOFTCAP_START[bomb_aoe]',
  KSOFTCAPSLOPEStat: 'K_SOFTCAP_SLOPE[stat]',
  KCRITCAP: 'K_CRIT_CAP',
  KLOOTMULTCAP: 'K_LOOT_MULT_CAP',
  KGLOBALSPEEDDEBUFFG1: 'K_GLOBAL_SPEED_DEBUFF[G1]',
  KTARGETTTK: 'K_TARGET_TTK',
  KTARGETGPMW1: 'K_TARGET_GPM[W1]',
  KRARERATETARGET: 'K_RARE_RATE_TARGET',
} as const;

/** Alias for convenience in consumers */
export type ConstantKey = (typeof K)[keyof typeof K];
